module.exports = __webpack_public_path__ + "b2649d578a51b3c27cd6c5d42b3503bf.png";